import React from 'react';
import { Button } from "@nextui-org/button";
import { Tooltip } from "@nextui-org/tooltip";
import { Download } from "lucide-react";
import { useTranslations } from 'next-intl';

// 定义props的接口
interface ActionButtonsProps {
  handleGenerateImage: () => void;
  isGenerating: boolean;
  handleDownload: () => void;
  isImageLoaded: boolean;
}

export const ActionButtons: React.FC<ActionButtonsProps> = ({ handleGenerateImage, isGenerating, handleDownload, isImageLoaded }) => {
  const t = useTranslations()
  return (
    <div className="flex space-x-2">
      <Tooltip content={t('ActionButtons.removeContent')}>
        <Button
          onClick={handleGenerateImage}
          color="primary"
          isLoading={isGenerating}
          disabled={!isImageLoaded || isGenerating}
        >
          {isGenerating ? `${t('ActionButtons.removing')}` : `${t('ActionButtons.remove')}`}
        </Button>
      </Tooltip>
      <Tooltip content={t('ActionButtons.downloadImage')}>
        <Button
          isIconOnly
          onClick={handleDownload}
          disabled={!isImageLoaded}
          aria-label={t('ActionButtons.downloadImage')}
        >
          <Download />
        </Button>
      </Tooltip>
    </div>
  );
};